// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"739660b5","605":"c0a786f4","809":"62452d41","981":"8d41dee0"}[chunkId] + ".chunk.js";
};